import React from 'react'
import {ReactComponent as IconEmptyBox} from "assets/images/icons/project-icons/empty-box.svg";
import Maybe from 'components/__new/common/Maybe';
import { Link } from 'react-router-dom';


const useEmptyData = () => {
    
    const TableEmptyData = ({title, subtitle, useSubtitle, actionButtonText, actionButtonClicked}) => {
    return (
        <div className="py-20 mx-auto text-center text-base">
            <div className="flex justify-center">
                <IconEmptyBox alt="Empty" className="h-36" />
            </div>
            <div className="text-[#101828] font-medium">
                {title || "No Data Available Yet"}
            </div>
            
            <Maybe condition={useSubtitle}>
                <div className="mt-1 text-[#4A5564]">
                    {subtitle || "Once you start transacting, it would appear here"}
                </div>
            </Maybe>
            
            <Maybe condition={actionButtonText?.length > 0}>
                <button onClick={actionButtonClicked} className="mt-1 text-ep-primary-500 underline">
                    {actionButtonText}
                </button>
            </Maybe>
        </div>
        )
    }
    
    
    const SearchBeneficiariesEmptyData = ({condition, message}) => {
        return (
            <Maybe condition={condition}>
                <div className="py-5 w-full flex items-center justify-center flex-col">
                    <IconEmptyBox />
                    <div className="font-medium text-sm mb-2">
                        {message || "No beneficiaries match your keyword"}
                    </div>
                </div>
            </Maybe>
        )
    }
    
    const ListBeneficiariesEmptyData = ({condition}) => {
        return (
            <Maybe condition={condition}>
                <div className="py-5 w-full flex items-center justify-center flex-col mt-14">
                    <IconEmptyBox />
                    <div className="font-medium text-sm mb-2">
                        No beneficiaries have been added yet
                    </div>
                    <Link to="/payments/beneficiaries" target="_blank" className="underline text-ep-primary">
                        Click here to add a new beneficiary
                    </Link>
                </div>
            </Maybe>
        )
    }
    
    return { TableEmptyData, SearchBeneficiariesEmptyData, ListBeneficiariesEmptyData }
}

export default useEmptyData